<style lang="less" rel="stylesheet/less" scoped>
.filter::-webkit-scrollbar {
    width: 6px;
    background-color: #F1F3F4;
}
/* scroll轨道背景 */
/* ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: yellow;
} */

/* 滚动条中能上下移动的小块 */
.filter::-webkit-scrollbar-thumb {
    height: 80px;
    border-radius: 6px;
    background-color: #cccccc;
}
.tool{
  position: absolute;
  z-index: 1000;
  top: 0;
  right:0;
  width:560px;
  height:100%;
  border-radius:24px 0px 0px 24px;
  background:#F1F3F4;
  float:right;
  text-align:left;
  // padding-top:85px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .filter{
    flex: 1;
    overflow-y: scroll;
    margin-top:50px;
  }
  .filterbox{
    display:flex;
    padding-left:30px;
    margin-bottom:25px;
    p{
      color:#00547E;
      font-weight:600;
      font-size:18px;
      margin-right:20px;
      min-width:40px;
      line-height:45px;
    }
    span{
      display: inline-block;
      width:100px;
      text-align:center;
      height: 45px;
      line-height: 45px;
      border-radius: 22px;
      margin-right: 15px;
      background: #EAECEC;
      color: #00547E;
      font-size:18px;
      margin-bottom:35px;
    }
    // span:hover,
    .cur {
      color: #0089CE;
      font-weight:bold;
      background: rgba(0,137,206, .2);
    }
  }
  .btn{
    width:100%;
    border-top:1px solid #D8E3E6;
    margin: 0px auto 37px;
    display:flex;
    justify-content:center;
    button{
      width:128px;
      height:60px;
      border-radius:30px;
      font-size:20px;
      margin-top:30px;
    }
    .reset{
      border:2px solid #0073AE;
      color:#0073AE;
    }
    .confirm{
      background:#008ACF;
      color:#ffffff;
      margin-left:25px;
    }
    .reset:hover {
      border-color: #4c9dc7;
      color: #4c9dc7;
    }
    .confirm:hover {
      background: #4cadde;
      color: #fff;
    }
  }

}

</style>
<template>
	<div class="tool">
      <div class="filter">
        <div class="filterbox">
          <p>科目</p>
          <div class="right">
            <span v-for="(item,index) in subjectList" :key="index" @click="checkLessonType(index,'selfSubjectIndex')" :class="[index==selfSubjectIndex? 'cur':'','cursor']">{{item}}</span>
          </div>
        </div>
        <div class="filterbox">
          <p>状态</p>
          <div class="right">
            <span v-for="(item,index) in lessonList" :key="index" @click="checkLessonType(index,'selfLessonIndex')" :class="[index==selfLessonIndex? 'cur':'','cursor']">{{item}}</span>
          </div>
        </div>
        <div class="filterbox">
          <p>年级</p>
          <div class="right"> 
            <span v-for="(item,index) in gradeList" :key="index" v-show="classGrades.indexOf(index) != -1" @click="checkLessonType(index,'selfGradeIndex')" :class="[index==selfGradeIndex? 'cur':'','cursor']">{{item}}</span>
          </div>
        </div>
        <div
          class="filterbox">
          <p>年份</p>
          <div class="right"> 
            <span v-for="(item,index) in classYears" :key="index" @click="checkLessonType(index,'classYearIndex')" :class="[index==classYearIndex? 'cur':'','cursor']">{{item}}</span>
          </div>
        </div>
        <div 
          class="filterbox">
          <p>学期</p>
          <div class="right"> 
            <span v-for="(item,index) in semesterList" :key="index" @click="checkLessonType(index,'semesterIndex')" :class="[index==semesterIndex? 'cur':'','cursor']">{{item}}</span>
          </div>
        </div>
      </div>
      <div class="btn">
        <button class="reset cursor" @click="reset">重置</button>
        <button class="confirm cursor" @click="confirm">确定</button>
      </div>
	</div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "tool",
  data() {
    return {
      subjectList:['全部科目','数学','语文','英语'],
      lessonList: ["全部课程", "学期中", "已结课"],
      semesterList: ['全部学期', '春季', '暑假', '秋季', '寒假'],
      // gradeList: [
      //   "全部年级",
      //   "一年级",
      //   "二年级",
      //   "三年级",
      //   "四年级",
      //   "五年级",
      //   "六年级",
      //   "七年级",
      //   "八年级",
      //   "九年级"
      // ],
      
      saveSetings:['selfGradeIndex',
      'selfLessonIndex',
      'selfSubjectIndex',
      'semesterIndex',
      'classYearIndex'
      ]
    };
  },
  props: ['classYears', 'classGrades'],
  computed: {
    ...mapState(['classYearIndex',
      'semesterIndex',
      'selfGradeIndex',
      'selfLessonIndex',
      'selfSubjectIndex',]),
    gradeList() {
      let grades = [
        "全部年级",
        "一年级",
        "二年级",
        "三年级",
        "四年级",
        "五年级",
        "六年级",
        "七年级",
        "八年级",
        "九年级"
      ]
      if (this.classGrades.indexOf(31) != -1) {
        grades[31] = '其他'
      }
      return grades
    }
  },
  mounted() {
  },
  methods: {
    ...mapMutations(['saveTool', 'saveToolIndex']),
    checkLessonType(index, type) {
      this.saveToolIndex({type, index})
      let res = {
        gradeIndex: this.selfGradeIndex,
        lessonIndex: this.selfLessonIndex,
        subjectIndex: this.selfSubjectIndex,
        classYear: this.classYears[this.classYearIndex],
        semesterIndex: this.semesterIndex
      }
      this.saveTool(res);
    },
    confirm(){
      // this.$emit('checkLessonType',this.selfGradeIndex,this.selfLessonIndex,this.selfSubjectIndex);
      this.$emit('toolShow',false)
    },
    reset(){
      this.saveSetings.forEach(v => {
        this.saveToolIndex({type: v, index: 0})
      })
      let res = {
        selfGradeIndex: this.selfGradeIndex,
        selfLessonIndex: this.selfLessonIndex,
        selfSubjectIndex: this.selfSubjectIndex,
        classYear: this.classYears[this.classYearIndex],
        semesterIndex: this.semesterIndex
      }
      this.saveTool(res);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bussiness/class/tool.vue